import { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomBlockButton from '../../../components/buttons/block-button/v1/CustomBlockButton';
import { Container, MenuButton, SelectorBtnBox, Wrapper } from './index.styled';
import MenuListComponent from './menu/MenuList.component';
import CustomImage from '../../../components/image/v1/CustomImage';
import { ClickableWrapper } from '../../../components/clickable-wrapper/v1';
import MenuListV2Component from './menu/MenuListV2.component';

const MAIN_CLIENT_ORIGIN = process.env.REACT_APP_MAIN_CLIENT_ADDRESS;

const SecondaryNavbarMainComponent = (props) => {
    const workspaceRedux = useSelector(state => state.workspaceRedux);
    const [menuListOpen, setMenuListOpen] = useState(false);

    const handleRouteToSelect = () => {
        window.location.href = `${MAIN_CLIENT_ORIGIN}/workspace/select`
    }

    const toggleMenuListOpen = (open) => {
        setMenuListOpen(open);
    }

    return (
        <>
            <Container>
                <ClickableWrapper
                    isActive={menuListOpen}
                    onClickOutside={() => setMenuListOpen(false)}
                >
                    <Wrapper>
                        <MenuButton
                            type='button'
                            onClick={() => toggleMenuListOpen(!menuListOpen)}
                        >
                            <div className='wrapper'>
                                <div className='icon-figure'>
                                    <CustomImage
                                        src='/images/icon/menu_hamburg_808080.svg'
                                        alt="셀러툴 전체 서비스"
                                        loading='lazy'
                                    />
                                </div>
                                <div className='text'>전체 서비스</div>
                            </div>
                        </MenuButton>
                        {workspaceRedux?.workspaceInfo &&
                            <SelectorBtnBox>
                                <CustomBlockButton
                                    type='button'
                                    className='button-el'
                                    onClick={() => handleRouteToSelect()}
                                >
                                    {workspaceRedux.workspaceInfo.name}
                                </CustomBlockButton>
                            </SelectorBtnBox>
                        }
                    </Wrapper>
                    {menuListOpen &&
                        <MenuListV2Component
                            onCloseMenuList={() => toggleMenuListOpen(false)}
                        />
                    }
                </ClickableWrapper>
            </Container>
        </>
    );
}
export default SecondaryNavbarMainComponent;